<script>
import TheSubmenu from './nav-bar/TheSubmenu'

export default {
  components: {
    TheSubmenu,
  },
}
</script>



// WEBPACK FOOTER //
// assets/js/components/header/TheNavBar.vue